import { render, staticRenderFns } from "./bidRuleSet.vue?vue&type=template&id=53486dbd&scoped=true&"
import script from "./bidRuleSet.vue?vue&type=script&lang=js&"
export * from "./bidRuleSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53486dbd",
  null
  
)

export default component.exports